import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import type { AlertSettingParam } from "types/alerts.types"

import { formatSelectTelemetries, getEntityTelemetries } from "helpers/utils/telemetries"
import useDevices from "helpers/hooks/useDevices"
import TelemetryInput from "../TelemetryInput"

interface DeviceTelemetryInputProps {
  param: AlertSettingParam
  deviceId: number
}

const DeviceTelemetryInput = ({ param, deviceId }: DeviceTelemetryInputProps) => {
  const { t } = useTranslation()
  const { devsWRelsById } = useDevices()

  const device = useMemo(() => (devsWRelsById || {})[deviceId], [devsWRelsById, deviceId])
  const deviceType = useMemo(() => device?.device.device_type, [device])
  const deviceSettings = useMemo(() => device?.device.settings, [device?.device.settings])

  const telemetries = useMemo(
    () => getEntityTelemetries("device", { deviceType, deviceSettings }),
    [deviceSettings, deviceType],
  )

  const selectTelemetries = useMemo(
    () => formatSelectTelemetries(telemetries, t) || [],
    [telemetries, t],
  )

  return <TelemetryInput param={param} telemetries={selectTelemetries} />
}

export default DeviceTelemetryInput
